document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    // Select all elements with class 'snize-suggestion'
    const suggestionItems = document.querySelectorAll(".snize-suggestion");
    console.log("suggestionItems", suggestionItems);

    // Select the container where you want to append them
    const container = document.querySelector(".snize-header");

    // Loop through each suggestion item and append it to the container
    if (suggestionItems.length > 0 && container) {
      suggestionItems.forEach((item) => {
        const clonedItem = item.cloneNode(true); // Clone to keep the original
        container.appendChild(clonedItem);
      });
    }
  }, 2000);

  const searchInput = document.querySelector(
    ".live-search-form .form-field-input"
  );
  const cancelButton = document.querySelector(".live-search-takeover-cancel");

  if (cancelButton && searchInput) {
    cancelButton.addEventListener("click", function () {
      console.log("getttHerer");
      searchInput.value = ""; // Clear the search input
      searchInput.focus(); // Optionally, keep focus on the input
    });
  }

  const stickyBtn = document.querySelector(".sticky-add-to-cart");
  const mainAddToCart = document.querySelector(".product-form--atc-button");

  function toggleStickyButton() {
    if (!mainAddToCart) return;

    const buttonRect = mainAddToCart.getBoundingClientRect();
    const isButtonVisible = buttonRect.bottom > 0;

    if (isButtonVisible) {
      stickyBtn.classList.remove("show"); // Hide with animation
    } else {
      stickyBtn.classList.add("show"); // Show with animation
    }
  }

  // Run on scroll
  window.addEventListener("scroll", toggleStickyButton);

  // Trigger click on main Add to Cart button
const stickyAddToCart = document.getElementById("sticky-atc-text");

if (stickyAddToCart && mainAddToCart) {
  stickyAddToCart.addEventListener("click", function () {
    mainAddToCart.click();
  });
}

  // Initial check in case the page loads scrolled
  toggleStickyButton();

  var variantOptions = document.querySelectorAll(
    ".variants-ui__option-value"
  );
  var priceElement = document.querySelector(".money[data-price]");
  // var stickyAddToCart = document.getElementById("sticky-add-to-cart");
  var priceDisplay = document.querySelector(
    ".sticky-add-to-cart .product-price"
  );
  var buyNowButton = document.querySelector(".shopify-payment-button");
  var DeliveryText = document.querySelector(".delivery-text-container");
  function updatePriceAndStock() {
    console.log("getting hereee");

    // console.log("mainAddToCartText",mainAddToCartText)
    setTimeout(() => {
 
      
      if (!variantOptions || !priceElement || !stickyAddToCart || !priceDisplay || !buyNowButton )
      var mainAddToCartText;
      if (mainAddToCart?.querySelector(".atc-button--text")) {
        mainAddToCartText =
          mainAddToCart?.querySelector(".atc-button--text").innerText;
      } else {
        mainAddToCartText = mainAddToCart?.innerText;
      }


      // Update price
      const updatedPrice =
        document.querySelector(".money[data-price]")?.innerText;
      if (updatedPrice) {
        priceDisplay.innerText = updatedPrice;
      }

      // Check if "Add to Cart" is disabled (Sold Out)
      if (mainAddToCart && mainAddToCart.hasAttribute("disabled")) {
        stickyAddToCart.innerText = "Sold Out";
        stickyAddToCart.style.background = "#ccc"; // Gray out
        stickyAddToCart.style.cursor = "not-allowed";
        stickyAddToCart.disabled = true;
        if(buyNowButton){
        buyNowButton.style.display = "none";
        }
         if(DeliveryText){
        DeliveryText.style.display = "none";
         }
      } else {
         if(buyNowButton){
        buyNowButton.style.display = "block";
        }
       if(DeliveryText){
        DeliveryText.style.display = "block";
         }
        if(!stickyAddToCart) return
        stickyAddToCart.innerText = mainAddToCartText;
        stickyAddToCart.style.background = "#fe6d07";
        stickyAddToCart.style.cursor = "pointer";
        stickyAddToCart.disabled = false;
       
      }
    }, 500);
  }

  // Listen for variant changes
  // variantOptions.forEach(function(variantOption) {
  // variantOption.addEventListener("click", function() {
  //  $('.iia-drawer-close').click()
  // updatePriceAndStock();
  // })
  // })
 
  
  const whatsappLinks = document.querySelectorAll(".whatsapp-link");

  function updateWhatsAppLinks() {
    setTimeout(() => {
      const variantUrl = window.location.href;

      whatsappLinks.forEach((link) => {
        const [baseUrl, existingMessage] = link.href.split("?text=");
        const decodedMessage = decodeURIComponent(existingMessage || "");

        const messageWithoutLink = decodedMessage
          .replace(/Product Link: https:\/\/[^\s]+/g, "")
          .trim();

        const updatedMessage = `${messageWithoutLink} \nProduct Link: ${variantUrl}`;

        link.href = `${baseUrl}?text=${encodeURIComponent(updatedMessage)}`;
      });
    }, 100);
  }
function iiaDrawerClickHandler() {
  console.log("tttt")
    const target = document.querySelector('.iia-list');
    const mainAddToCart = document.querySelector(".product-form--atc-button");

    // Remove old injected text if it exists
    const existing = target?.parentNode.querySelector(".injected-text");
    if (existing) existing.remove();

    if (target) {
        const textNode = document.createElement("h3");
        textNode.className = "injected-text";

        const atcText = mainAddToCart?.innerText.toLowerCase() || "";
        console.log("atcText", atcText);

        let statusText = "";

        if (atcText.includes("add to cart")) {
            statusText = "In stock - Ready to ship";
        } else if (atcText.includes("pre order") || atcText.includes("preorder")) {
            statusText = "Preorder";
        } else if (atcText.includes("sold out") || atcText.includes("out of stock")) {
            statusText = "Out of stock";
        }

        if (statusText) {
            textNode.innerText = statusText;
            target.parentNode.insertBefore(textNode, target);
            console.log("Appended:", statusText);
        }
    }
}

// Attach the event listener only once
document.addEventListener("click", function (e) {
    const drawerLink = e.target.closest(".iia-drawer-link");
    if (drawerLink) {
        iiaDrawerClickHandler();
    }
});


// Variant click logic
variantOptions.forEach(function (variantOption) {
    variantOption.addEventListener("click", function () {
        updatePriceAndStock();
        updateWhatsAppLinks();
    });
});

// Initial function calls
updatePriceAndStock();
updateWhatsAppLinks();



});
